module.exports = __webpack_public_path__ + "static/media/redX.c3d57306.svg";